import util from '@bmp-vue/core/api/util'

const controller = 'ActionGroupAccess'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetAllByGroup: function (dto) {
    return util.Axios.GetAll(controller + '/GetAllByGroup', dto)
  },
  PutByGroup: function (dto) {
    return util.Axios.Put(controller + '/PutByGroup', dto.groupID, dto)
  },
})
